import React from 'react';
import { m as motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { FULL_MOCKUP_URL } from '../data/images';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-mp-black pt-14 pb-16 md:pt-20 md:pb-24" data-id="element-155" data-mp="4n9wadwh9812">
      <div className="pointer-events-none absolute inset-0 court-lines opacity-60" aria-hidden="true" data-id="element-156" data-mp="128pi5dka8x4k" />
      <div className="pointer-events-none absolute -top-40 right-0 h-[520px] w-[520px] rounded-full opacity-50 md:right-10" style={{
      background: 'radial-gradient(circle, rgba(8,117,209,0.35), transparent 65%)'
    }} aria-hidden="true" data-id="element-157" data-mp="xb5qnbykqnuo" />
      <Container className="relative z-10" data-id="element-158" data-mp="3d2labedjz91r">
        <div className="flex flex-col items-center gap-12 md:flex-row md:items-center md:gap-8" data-id="element-159" data-mp="3czfoc8080na9">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: easeOut
        }} className="w-full md:w-[52%]" data-id="element-160" data-mp="384jtz17ihntz">
            <SectionTag tone="lime" data-id="element-161" data-mp="39albailw2w59">Para monitores y entrenadores de pádel</SectionTag>

            <h1 className="mt-5 font-heading text-4xl font-semibold uppercase leading-[1.05] text-mp-white sm:text-5xl md:text-[3.2rem]" data-id="element-162" data-mp="39cpfl1np9x62">
              ¿Cuántas clases más vas a improvisar?
            </h1>

            <p className="mt-6 max-w-[650px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-163" data-mp="358rg2pugqkch">
              Maestro en Pista reúne 5 tomos, 250+ páginas y herramientas listas para llevar a pista, para que abras
              el PDF, elijas qué trabajar y entres a clase sabiendo exactamente qué hacer y por qué.
            </p>

            {/* Mobile mockup sits before the CTA */}
            <div className="mt-8 md:hidden" data-id="element-164" data-mp="2hlj983hdz38c">
              <HeroMockup priority data-id="element-165" data-mp="2ljpaivzggqlv" />
            </div>

            <CTAButton href="#oferta" className="mt-8 w-full sm:w-auto" showArrow data-id="element-166" data-mp="2lmlcqwic61g4">
              Quiero Maestro en Pista
            </CTAButton>

            <p className="mt-4 text-center text-xs text-mp-gray sm:text-left sm:text-sm" data-id="element-167" data-mp="na9zwokqxekx">
              ✓ Acceso inmediato &nbsp; ✓ 100% digital &nbsp; ✓ Desde 16,90€ &nbsp; ✓ Móvil, tablet u ordenador
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: easeOut,
          delay: 0.1
        }} className="hidden w-full md:block md:w-[48%]" data-id="element-168" data-mp="db2erf7rsfn9">
            <HeroMockup priority data-id="element-169" data-mp="111y8wizp7mxo" />
          </motion.div>
        </div>
      </Container>
    </section>;
}
function HeroMockup({
  priority = false
}: {
  priority?: boolean;
}) {
  return <div className="relative" data-id="element-170" data-mp="3ltgo5tkf8wpx">
      <div className="pointer-events-none absolute inset-0 -z-10 rounded-full opacity-70 blur-2xl" style={{
      background: 'radial-gradient(circle, rgba(8,117,209,0.4), transparent 70%)'
    }} aria-hidden="true" data-id="element-171" data-mp="3ltqgvowuphzb" />
      <img src={FULL_MOCKUP_URL} alt="Kit completo Maestro en Pista: 5 tomos, 5 bonos y Kit de Ejecución" width={800} height={800} fetchPriority={priority ? 'high' : 'auto'} loading={priority ? 'eager' : 'lazy'} className="mx-auto w-full max-w-[560px] drop-shadow-2xl" data-id="element-172" data-mp="1x7hy7ki4cf41" />
    </div>;
}